/* eslint-disable func-names */
/* eslint-disable dot-notation */
/* eslint-disable eqeqeq */
/* eslint-disable no-continue */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */

function trigger_interaction(eventLabel = '', eventType, eventValue) {
  _check_initialized()
  _queue_action({
    function: '_trigger_interaction',
    eventLabel,
    eventType,
    eventValue
  })
  _process_queue()
}

function trigger_pageview(dataObject) {
  _check_initialized()
  _queue_action({
    function: '_trigger_pageview',
    dataObject
  })
  _process_queue()
}
function _check_initialized() {
  window.CDC = window.CDC || {}
  window.CDC.SPA_App = window.CDC.SPA_App || {}

  if (!window.CDC.SPA_App.initialized) {
    if (document.body && document.body.classList.contains('dmat-load-complete') !== -1) {
      window.CDC.SPA_App.initialized = true
    } else if (!window.CDC.SPA_App.listenerAdded) {
      window.CDC.SPA_App.listenerAdded = true
      document.body.addEventListener('dmat-load-complete', function () {
        window.CDC.SPA_App.initialized = true
        _process_queue()
      })
    }
  }
}
function _queue_action(action) {
  window.CDC.SPA_App.action_queue = window.CDC.SPA_App.action_queue || []
  window.CDC.SPA_App.action_queue.push(action)
}

function _process_queue() {
  if (window.CDC.SPA_App.initialized && window.CDC.SPA_App.action_queue && window.CDC.SPA_App.action_queue.length > 0) {
    const actions = window.CDC.SPA_App.action_queue
    window.CDC.SPA_App.action_queue = []
    actions.forEach(function (action) {
      if (action.function === '_trigger_interaction') {
        _trigger_interaction(action.eventLabel, action.eventType, action.eventValue)
      } else if (action.function === '_trigger_pageview') {
        _trigger_pageview(action.dataObject)
      }
    })
  }
}

function _trigger_interaction(eventLabel, eventType, eventValue) {
  if (window.hasOwnProperty('_satellite')) {
    var dataObject = {}
    const projectName = 'DASH SHPE'
    dataObject.label = eventLabel
    dataObject.interactionType = eventType || 'o'
    dataObject.interactionValue = `${projectName} | ${eventLabel} | ${eventValue}`

    window._satellite.track('interaction', dataObject)
  } else {
    console.error('Analytics library finished rendering but satellite is undefined')
  }
}

function _trigger_pageview(dataObject) {
  if (window.hasOwnProperty('_satellite')) {
    window._satellite.track('pageview', dataObject)
  } else {
    console.error('Analytics library finished rendering but satellite is undefined')
  }
}

export { trigger_interaction, trigger_pageview }